import { isDecimalAmount, sumAmounts } from '@platform/design-system';
import type { Order } from './orders.ts';

export type DispatchFees = Readonly<Record<string, string>>;

export const feesAtRate = (orders: readonly Pick<Order, 'id'>[], rate: string | null): DispatchFees =>
  Object.fromEntries(orders.map((order) => [order.id, rate ?? '']));

export const isValidFee = (fee: string): boolean => isDecimalAmount(fee.trim());

export const allFeesValid = (fees: DispatchFees): boolean => Object.values(fees).every(isValidFee);

export const amountToCollect = (order: Pick<Order, 'totals'>, fee: string): string =>
  sumAmounts([order.totals.itemsSubtotal, isValidFee(fee) ? fee.trim() : '0']);

export const trimmedFees = (fees: DispatchFees): DispatchFees =>
  Object.fromEntries(Object.entries(fees).map(([orderId, fee]) => [orderId, fee.trim()]));
